const initialState = {
    "streamData": {},
};

export function livestream(state = initialState, action) {
    if (action.type === "RESERVATION_DATA_SET") {
        let newState = {...state};
        if (!action.reservation.attributes.livestream) return newState;
        return {
            ...newState,
            streamData: {...action.reservation.attributes.livestream},
        };
    } else if (action.type === "RESERVATION_CLEARED") {
        return initialState
    } else {
        return state;
    }
}
